import {useClientLimitedEvents} from "@twigsby/client-data";
import {
    Button,
    ColourSolid,
    ColourOutline,
    ContentBlock,
    ContentLoader,
    useTranslation
} from "@twigsby/frontend-framework";
import React from "react";
import {useNavigate} from "react-router-dom";
import {useSite} from "../../Providers/SiteInterfaceProvider";

const GetInTouch = () => {
    const navigate = useNavigate();
    const { UpdateSiteContact } = useSite();
    const { t } = useTranslation();
    const { data, status, error } = useClientLimitedEvents();

    return (
        <>
            {status === 'loading' ? (
                <ContentLoader rounded={true} childHeight={'15em'} childCount={1} />
            ) : status === "error" ? (
                <ContentBlock error={true} title={error.name} content={error.message} />
            ) : (
                <ContentBlock
                    stacked={true}
                    showBorder={true}
                    title={t('getInTouch.title')}
                    content={t('getInTouch.description')}
                    media={
                        <img src={`${process.env.PUBLIC_URL}/images/get-in-touch.svg`} alt={t('getInTouch.imageAlt')} />
                    }
                    extraClass={'text-center'}
                    button={
                        <>
                            <Button squared={true} title={t('getInTouch.actions.message')} onClick={() => UpdateSiteContact(true)} colour={ColourSolid.Primary}/>
                            <a href={'https://www.ukpostbox.com/contact/callback-request'} className={'btn secondary btn-squared'} target={'_blank'} rel={"nofollow noopener noreferrer"}>{t('getInTouch.actions.call')}</a>
                        </>
                    }
                />
            )}
        </>
    )
}

export default GetInTouch
